import {
  ButtonBottomCombination,
  ButtonBottomCombinationProps,
} from '../../molecules/ButtonBottomCombination/ButtonBottomCombination';

export function DialogBottomCombination(props: ButtonBottomCombinationProps) {
  return <ButtonBottomCombination {...props} />;
}

export const DialogBottomCombinationType = (<DialogBottomCombination />).type;
